import { Component, OnInit, ViewChild } from '@angular/core';
import { AdvanceDashboardService, DashboardAction } from '../dashboard.service';
import { AppDevNotifyComponent } from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';
import { AuthService, RolePermission } from 'src/app/services/auth.service';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { NavbarService } from 'src/app/core/navigation/navbar/services/navbar.service';
import { RouteConfigService } from 'src/app/routing/route-config.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { ExcelExportService } from 'src/app/common/excel-export-service';
import { Subject } from 'rxjs';
import { ValueChangedEvent } from 'devextreme/ui/select_box';
import { BiDashboardComponent } from 'src/app/widgets/bi-dashboard/bi-dashboard.component';
import { BaseService } from 'src/app/services/base.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
	selector: 'app-dashboard-manager',
	templateUrl: './dashboard-manager.component.html',
	standalone: false,
})
export class DashboardManagerComponent implements OnInit {
	title = 'DashboardAngularApp';
	workingMode: string = 'Viewer';
	dashboardId: string = '';
	dashboards = [];

	DevExpressApiUrl = '';
	apiHeader: {};
	constructor(
		private baseService: BaseService,
		private localStorageService: LocalStorageService,
		private readonly authService: AuthService,
		private readonly _routeConfigService: RouteConfigService,
		private readonly _navbarService: NavbarService,
		private readonly shareDataService: ShareDataService,
		private readonly dashboardService: AdvanceDashboardService,
	) {
		this.shareDataService.CleanData();
		if (this.baseService.getNewOptions() != null && this.baseService.getNewOptions().headers != null) {
			this.apiHeader = this.baseService.getNewOptions().headers;
			this.DevExpressApiUrl = this.baseService.getCorrectUrl("dashboard");
		}

		this.reloadData('');
	}

	ngOnInit() {
		this.getIcons();
	}

	changeWorkingMode() {
		this.workingMode = this.toggleMode(this.workingMode);
	}

	toggleMode(mode: string) {
		return mode === 'Viewer' ? 'Designer' : 'Viewer';
	}

	refreshCache = false;

	reloadData(action: string) {
		this.dashboardService.dashboardList().subscribe({
			next: (dashboardData) => {
				if (!dashboardData || !Array.isArray(dashboardData)) {
					console.error('Invalid dashboard data received');

					return;
				}

				this.dashboards = dashboardData;

				if (action === 'reload' || this.dashboardId === '') {
					const defaultDashboard = this.dashboards[0];

					if (defaultDashboard) {
						this.dashboardId = defaultDashboard.id;
						this.IsEnableCache = defaultDashboard.isEnableCache ?? false; // Default to false if undefined
						this.createMenu(false); // Initialize the selected dashboard
					}
				}
			},
			error: (err) => {
				console.error(
					'Failed to load dashboard list:',
					err,
				);
				AppDevNotifyComponent.ErrorMessage('Failed to load dashboards');
			},
		});
	}

	popupMenuVisible = false;
	dashboardName = '';
	IsEnableCache = false;
	workingdashboardId = null;

	createMenu(enablePopup: boolean = true) {
		if (!this.dashboardId || !this.dashboards?.find((x) => x.id === this.dashboardId)) {
			AppDevNotifyComponent.ErrorMessage('Please select a valid dashboard.');

			return;
		}

		this.dashboardService.GetDashboardMenus(
			this.dashboardId,
			{
				showLoadingIndicator: true,
			},
		).subscribe({
			next: (dashboardData) => {
				if (!dashboardData?.table?.[0]) {
					console.warn(
						'No menu data received for dashboard',
						this.dashboardId,
					);

					return;
				}

				const menuItem = dashboardData.table[0];
				this.menuIcon = menuItem.menuIcon ?? '';
				this.dashboardName = menuItem.caption ?? '';
				this.IsEnableCache = menuItem.isEnableCache ?? false;
				this.workingdashboardId = this.dashboardId;

				if (enablePopup) {
					this.popupMenuVisible = true;
				}

				if (this.menuIcon && this.icondata) {
					this.icon = this.icondata.find((x) => x.icon === this.menuIcon) ?? null;
				}
			},
			error: (err) => {
				console.error(
					'Failed to load dashboard menu:',
					err,
				);
				AppDevNotifyComponent.ErrorMessage('Failed to load dashboard menu');
			},
		});
	}

	menuIcon = '';
	data: DashboardAction;
	updateRoute() {
		this.data = new DashboardAction();
		this.data.dashboardId = this.dashboardId;
		this.data.menuIcon = this.menuIcon;
		this.data.title = this.dashboardName;
		this.data.IsEnableCache = this.IsEnableCache;

		this.dashboardService.AddNewDashboardMenu(this.data).subscribe((dashboardData) => {
			if (dashboardData?.flag) {
				this.reloadData('');
				this.refreshCache = this.IsEnableCache;
				AppDevNotifyComponent.SuccesMessage(dashboardData.msg);
				this.menurefresh();
			} else {
				AppDevNotifyComponent.ErrorMessage('Sorry, something went wrong. Please try again later.');
			}

			this.popupMenuVisible = false;
		});
	}

	menurefresh() {
		this._navbarService.loadNavbarItems();
		this._routeConfigService.initializeRoutes();

		this.authService.getPermissions(
			{
				showLoadingIndicator: true,
			},
		).subscribe(
			{
				next: (permissions) => {
					this.localStorageService.set(
						RolePermission.storage_key,
						permissions,
					);
				},
			},
		);
	}

	eventsSubjectdashboard: Subject<string> = new Subject<string>();

	deleteDashboard() {
		this.dashboardService.DeleteDashboardData(this.dashboardId).subscribe((dashboardData) => {
			// Delete the dashboard with the specified ID
			this.proceedingInfoPopup = false;
			AppDevNotifyComponent.SuccesMessage('Dashboard deleted successfully.');
			this.eventsSubjectdashboard.next('deleteDashboard');
			this.reloadData('reload');
			this.menurefresh();
		});
	}

	popupMenuAccessVisible = false;
	MenuAccess() {
		this.popupMenuAccessVisible = true;
	}

	proceedingInfoPopup: boolean = false;
	HideDeletePopup() {
		this.proceedingInfoPopup = false;
	}

	DeletePopupDashboard() {
		this.proceedingInfoPopup = true;
	}

	headers: any;
	icondata: any;
	icon: any;
	@ViewChild(
		'dropDownBoxInstance',
		{ static: false },
	) dropDownBoxInstance: DxDropDownBoxComponent;

	getIcons() {
		this.dashboardService.GetIcons().subscribe((Data) => {
			this.icondata = Data;

			if (this.menuIcon && this.icondata) {
				this.icon = this.icondata.find((x) => x.icon == this.menuIcon);
			} else if (this.icondata != null && this.icondata != undefined) {
				this.icon = this.icondata[0];
			}
		});
	}

	menuUrlIcon = '';
	onSelectionChanged(e) {
		if (e.selectedRowsData?.[0] != null && e.selectedRowsData[0] != undefined) {
			if (e.selectedRowsData[0].icon) {
				this.menuIcon = e.selectedRowsData[0].icon;
			}

			this.icon = e.selectedRowsData[0];
			this.menuUrlIcon = '<img src=\'/assets/font-awesome/svgs/' + this.icon.folderName + '/' + this.icon.fileName.trimEnd() + '\' alt=\'menuicon\' class=\'w-6 h-5\' />';
		}

		this.dropDownBoxInstance.instance.close();
	}

	get workingModeText() {
		return 'Switch to ' + this.toggleMode(this.workingMode);
	}

	@ViewChild(BiDashboardComponent) biDashboard!: BiDashboardComponent;
	ClearCache() {
		if (!this.dashboardId) {
			AppDevNotifyComponent.ErrorMessage('No dashboard selected');

			return;
		}

		this.dashboardService.ClearCacheDashboard(this.dashboardId).subscribe({
			next: () => {
				if (this.biDashboard) {
					this.biDashboard.handleClearCache();
				}

				AppDevNotifyComponent.SuccesMessage('Cache cleared successfully.');
			},
			error: (err) => {
				console.error(
					'Failed to clear cache:',
					err,
				);
				AppDevNotifyComponent.ErrorMessage('Failed to clear cache');
			},
		});
	}

	onDashboardValueChanged($event: ValueChangedEvent) {
		if (this.createMenu) {
			this.createMenu(false);
		}
	}
}